// Todos are rendered in the right-side TodoPanel (.details-card) rather than
// inline in the chat stream, so the inline tool call produces no output.
export function TodoCard() {
  return null;
}
